import "core-js/modules/es.array.push.js";
let vm = null; //介质
import request from "../util/request";
export default {
  // eslint-disable-next-line vue/multi-word-component-names
  name: "Login",
  data() {
    // let validatePsdReg = (rule, value, callback) => {
    //   if (!value) {
    //     return callback(new Error('请输入密码'))
    //   }
    //   if (!/^(?![\d]+$)(?![a-zA-Z]+$)(?![^\da-zA-Z]+$)([^\u4e00-\u9fa5\s]){6,20}$/.test(value)) {
    //     callback(new Error('请输入6-20位英文字母、数字或者符号（除空格），且字母、数字和标点符号至少包含两种'))
    //   } else {
    //     callback()
    //   }
    // };

    return {
      loginType: 'password',
      // 当前登录方式，'password' 或 'sms'
      registerDialogVisible: false,
      // 控制注册弹窗的显示
      createBy: sessionStorage.getItem('userName'),
      userAlias: sessionStorage.getItem('userAlias'),
      loginForm: {
        userName: '',
        phoneNumber: '',
        captcha: '' // 用于存放验证码
      },

      registerForm: {
        userName: '',
        userAlias: '',
        passWord: '',
        confirmPassword: '',
        balance: 0
      },
      rules: {
        userName: [
        // { pattern:/^([a-z0-9]([a-z0-9-.]*)[a-z0-9])$|^([a-z0-9])$/, message: '只能输入小写字母、数字、点号.和横线-并且点号 . 和横线 - 不能在开头或结尾', trigger: 'blur' },
        {
          required: true,
          min: 2,
          max: 50,
          message: '用户名不能为空,长度： 2 ~ 50',
          trigger: 'blur'
        }
        // {validator: validateUserName, required: true, message: '用户名重复，重新输入', trigger: 'blur'}
        ],

        phoneNumber: [{
          required: true,
          message: '手机号不能为空',
          trigger: 'blur'
        }, {
          pattern: /^[1][3-9][0-9]{9}$/,
          message: '请输入有效的手机号',
          trigger: 'blur'
        }],
        captcha: [{
          required: true,
          message: '验证码不能为空',
          trigger: 'blur'
        }, {
          pattern: /^[0-9]{4}$/,
          message: '请输入有效的验证码',
          trigger: 'blur'
        }]
      },
      registerRules: {
        userName: [{
          required: true,
          message: '请输入用户名',
          trigger: 'blur'
        }],
        userAlias: [{
          required: true,
          message: '请输入姓名',
          trigger: 'blur'
        }],
        passWord: [{
          required: true,
          message: '请输入密码',
          trigger: 'blur'
        }],
        confirmPassword: [{
          required: true,
          message: '请确认密码',
          trigger: 'blur'
        }, {
          validator: this.validatePasswordMatch,
          trigger: 'blur'
        }],
        balance: [{
          type: 'number',
          message: '请输入有效的数字',
          trigger: 'blur'
        }]
      },
      countdown: 0,
      // 倒计时秒数
      loading: false // 按钮加载状态
    };
  },

  created() {
    vm = this; //=====关键
    // this.load();
  },

  methods: {
    // load(){},
    // 切换登录方式
    toggleLoginType() {
      this.loginType = this.loginType === 'password' ? 'sms' : 'password';
      this.loginForm.captcha = ''; // 清空验证码字段
      this.loginForm.userName = ''; // 清空用户名字段
      this.loginForm.phoneNumber = ''; // 清空手机号字段
      // this.countdown = 0; // 重置倒计时
    },

    goToRegister() {
      this.registerDialogVisible = true;
      this.registerForm.userName = '';
      this.registerForm.userAlias = '';
      this.registerForm.password = '';
      this.registerForm.confirmPassword = '';
      // 重置表单校验状态
      this.$nextTick(() => {
        if (this.$refs.registerForm) {
          this.$refs.registerForm.resetFields();
        }
      });
      // 使用 Vue Router 跳转到注册页面
      // this.$router.push({ path: '/UserCreate'});
    },

    handleRegister() {
      this.$refs.registerForm.validate(valid => {
        if (valid) {
          // 调用后端接口注册用户
          this.registerForm.createBy = this.registerForm.userName;
          request.post("/user/createReantalUser", this.registerForm).then(res => {
            // this.tablee = res.data
            // this.dialogFormVisible = false
            // this.query()
            if (res.code === '0') {
              this.$message({
                type: 'success',
                message: '注册成功!'
              });
              this.registerDialogVisible = false;
              setTimeout(sessionStorage.setItem("userName", this.registerForm.userName), request.get("/user/login", {
                params: {
                  userName: this.registerForm.userName,
                  passWord: this.registerForm.passWord
                }
              }).then(res => {
                if (res.code === "0") {
                  // localStorage.setItem('ip', "http://192.168.0.115:8080");//ip地址
                  localStorage.setItem('ip', "http://120.78.159.42:8080"); //ip地址
                  sessionStorage.setItem('authorityId', res.data.authorityId);
                  sessionStorage.setItem("userName", this.registerForm.userName);
                  sessionStorage.setItem("userAlias", res.data.userAlias);
                  localStorage.setItem("userName", res.data.userName);
                  sessionStorage.setItem("roleId", res.data.roleId);
                  sessionStorage.setItem("areaId", res.data.areaId);
                  sessionStorage.setItem("rentalUserIndex", res.data.rentalUserIndex);
                  this.$router.push({
                    path: 'pay',
                    query: {}
                  });
                } else if (res.code === "500") {
                  this.$message({
                    type: 'error',
                    message: '用户名或密码错误!'
                  });
                } else if (res.code === "300") {
                  this.$message({
                    type: 'error',
                    message: '该账号未激活!'
                  });
                }
                let authorityId = sessionStorage.getItem('authorityId');
                authorityId.split(",");
              }), 2000);
            }
          });
        } else {
          this.$message.error('请填写完整信息');
        }
      });
    },
    validatePasswordMatch(rule, value, callback) {
      if (value !== this.registerForm.passWord) {
        callback(new Error('两次输入的密码不一致'));
      } else {
        callback();
      }
    },
    // 获取验证码
    sendVerificationCode() {
      const phoneRegex = /^[1][3-9][0-9]{9}$/;
      const phoneNumber = this.loginForm.phoneNumber.trim();
      if (this.countdown > 0) return; // 如果正在倒计时，则不执行

      if (!this.loginForm.phoneNumber) {
        this.$message({
          type: 'error',
          message: '请输入手机号'
        });
        return;
      }
      if (!phoneRegex.test(this.loginForm.phoneNumber)) {
        this.$message({
          type: 'error',
          message: '请输入有效的手机号!'
        });
        return;
      }
      this.loading = true;
      // 调用后端发送验证码接口
      request.get("/user/getCode", {
        params: {
          mobile: phoneNumber,
          type: '2' // 根据后端定义的验证码类型
        }
      }).then(res => {
        const {
          sessionId
        } = res.data; // 假设返回包含 sessionId
        console.log("Session ID:", sessionId);
        this.$message({
          type: 'success',
          message: '验证码已发送，请查收!'
        });
        // 启动倒计时
        this.startCountdown();
      }).catch(error => {
        console.log(error);
        this.$message({
          type: 'error',
          message: '验证码发送失败，请稍后再试!'
        });
      }).finally(() => {
        this.loading = false;
      });
      // setTimeout(() => {
      //   this.loading = false;
      //   this.$message({
      //     type: 'success',
      //     message: '验证码已发送，请查收'
      //   });
      //   this.startCountdown();
      // }, 1000); // 模拟请求延迟
    },

    // 启动倒计时
    startCountdown() {
      this.countdown = 60; // 设定倒计时秒数
      const interval = setInterval(() => {
        if (this.countdown === 0) {
          clearInterval(interval);
        } else {
          this.countdown--;
        }
      }, 1000);
    },
    toSession(loginForm) {
      sessionStorage.setItem('userName', vm.loginForm.userName);
      console.log(loginForm);
      if (this.loginType === 'password') {
        if (vm.loginForm.userName != null && vm.loginForm.userName != '') {
          if (vm.loginForm.passWord != null && vm.loginForm.passWord != '') {
            vm.toLogin();
          } else {
            this.$message({
              type: 'error',
              message: '请输入密码!!'
            });
          }
        } else {
          this.$message({
            type: 'error',
            message: '请输入用户名和密码!'
          });
        }
      } else {
        if (vm.loginForm.phoneNumber != null && vm.loginForm.phoneNumber != '') {
          if (vm.loginForm.captcha != null && vm.loginForm.captcha != '') {
            let map = {
              mobile: vm.loginForm.phoneNumber,
              code: vm.loginForm.captcha
            };
            request.post('/user/mobile', map).then(res => {
              console.log(res);
              console.log(res.code);
              // console.log(res.data.data.userAlias)
              if (res.code == "200") {
                localStorage.setItem('ip', "http://120.78.159.42:8080"); //ip地址
                sessionStorage.setItem('authorityId', res.data.data.authorityId);
                sessionStorage.setItem("userName", res.data.data.userName);
                sessionStorage.setItem("userAlias", res.data.data.userAlias);
                localStorage.setItem("userName", res.data.data.userName);
                sessionStorage.setItem("roleId", res.data.data.roleId);
                sessionStorage.setItem("areaId", res.data.data.areaId);
                sessionStorage.setItem("rentalUserIndex", res.data.data.rentalUserIndex);
                this.$router.push({
                  path: 'home',
                  query: {}
                });
              } else if (res.code == "400") {
                this.$message({
                  type: 'error',
                  message: '验证码错误，请重新输入!'
                });
              } else if (res.code == "401") {
                this.$message({
                  type: 'error',
                  message: '验证码过期，请重新获取!'
                });
              }
            });
          } else {
            this.$message({
              type: 'error',
              message: '请输入验证码!'
            });
          }
        } else if ((vm.loginForm.phoneNumber == null || vm.loginForm.phoneNumber == '') && (vm.loginForm.captcha == null || vm.loginForm.captcha == '')) {
          this.$message({
            type: 'error',
            message: '请输入手机号和验证码!'
          });
        } else {
          this.$message({
            type: 'error',
            message: '请输入手机号!'
          });
        }
      }
    },
    toLogin() {
      sessionStorage.setItem("userName", vm.loginForm.userName);
      request.get("/user/login", {
        params: {
          userName: vm.loginForm.userName,
          passWord: this.loginForm.passWord
        }
      }).then(res => {
        if (res.code === "0") {
          localStorage.setItem('ip', "http://120.78.159.42:8080"); //ip地址
          // localStorage.setItem('ip', "http://192.168.0.184:9090");//ip地址
          // localStorage.setItem('ip', "http://192.168.0.115:8080");//ip地址
          sessionStorage.setItem('authorityId', res.data.authorityId);
          sessionStorage.setItem("userName", vm.loginForm.userName);
          sessionStorage.setItem("userAlias", res.data.userAlias);
          localStorage.setItem("userName", res.data.userName);
          sessionStorage.setItem("roleId", res.data.roleId);
          sessionStorage.setItem("areaId", res.data.areaId);
          sessionStorage.setItem("rentalUserIndex", res.data.rentalUserIndex);
          // this.$router.push({path: 'home', query: {}});
          this.$router.push({
            path: 'dataShow',
            query: {}
          });
        } else if (res.code === "500") {
          this.$message({
            type: 'error',
            message: '用户名或密码错误!'
          });
        } else if (res.code === "300") {
          this.$message({
            type: 'error',
            message: '该账号未激活!'
          });
        }
        console.log(res);
        let authorityId = sessionStorage.getItem('authorityId');
        authorityId.split(",");
        console.log(authorityId + "---authorityId");
        console.log(authorityId.split(","));
      });
    }
  }
};